import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBlogDetails, deleteBlog } from "../../../../utils/redux/blog/blogActions";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const BlogDetailsPage = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { selectedBlog } = useSelector(state => state.blog);

    useEffect(() => {
        dispatch(fetchBlogDetails(id));
    }, [id]);

    const handleDelete = async () => {
        const res = await dispatch(deleteBlog(id));
        if (res?.success) {
            toast.success("Deleted");
            navigate("/blogs");
        }
    };

    if (!selectedBlog) return <div>Loading...</div>;

    return (
        <div className="container py-4">
            <h2>{selectedBlog.title}</h2>
            <p><strong>Author:</strong> {selectedBlog.author}</p>
            <p><strong>Category:</strong> {selectedBlog.category?.name}</p>

            {selectedBlog.image?.url && (
                <img src={selectedBlog.image.url} width="300" alt="" />
            )}

            <div
                dangerouslySetInnerHTML={{ __html: selectedBlog?.content }}
            />

            <button
                className="btn btn-primary me-2"
                onClick={() => navigate(`/blogs/${id}/edit`)}
            >
                Edit
            </button>

            <button className="btn btn-danger" onClick={handleDelete}>
                Delete
            </button>
        </div>
    );
};

export default BlogDetailsPage;